"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metrics = exports.CustomMetricType = exports.consoleIntegration = exports.openTelemetryIntegration = exports.datadogBrowser = void 0;
const make_custom_metrics_sender_1 = require("./make-custom-metrics-sender");
var browser_1 = require("./browser");
Object.defineProperty(exports, "datadogBrowser", { enumerable: true, get: function () { return browser_1.datadogBrowser; } });
var node_1 = require("./node");
Object.defineProperty(exports, "openTelemetryIntegration", { enumerable: true, get: function () { return node_1.openTelemetryIntegration; } });
var common_1 = require("./common");
Object.defineProperty(exports, "consoleIntegration", { enumerable: true, get: function () { return common_1.consoleIntegration; } });
var types_1 = require("./types");
Object.defineProperty(exports, "CustomMetricType", { enumerable: true, get: function () { return types_1.CustomMetricType; } });
exports.metrics = (0, make_custom_metrics_sender_1.makeCustomMetricsSender)();
//# sourceMappingURL=index.js.map